import Vue from 'vue'
import store from '../../store/index.js'
import axios from 'axios'
import router from '../../router/index.js'

axios.defaults.baseURL = 'http://www.semitronix.com'
    // axios.defaults.baseURL = 'http://localhost:8081/api'

function closeData() {
    window.sessionStorage.removeItem('userCode')
    window.sessionStorage.removeItem('userCompany')
    window.sessionStorage.removeItem('userName')
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('userId')
    store.commit('setUserName', '')
    store.commit('setUserCode', '')
    store.commit('setUserCompany', '')
    store.commit('setToken', '')
    store.commit('setUserId', '')
}

// 请求拦截器
axios.interceptors.request.use(
    config => {
        const token = store.state.token;
        config.headers.token = token;
        token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.status === 200) {
            if (response.data.code == 106 || response.data.code == 500) {
                new Vue().$message({ type: 'error', message: '登录超时， 请重新登录！' })
                closeData()
                router.push('/login')
                return Promise.resolve(response);
            } else {
                return Promise.resolve(response);
            }
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                    // 401: 未登录
                    // 未登录则跳转登录页面，并携带当前页面的路径
                    // 在登录成功后返回当前页面，这一步需要在登录页操作。
                    // console.log('401 状态码含义');
                    break;
                case 403:
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                    // console.log('403 状态码含义');
                    break;
                case 404:
                    // 404请求不存在
                    // console.log('404 状态码含义');
                    break;
                case 500:
                    // closeData()
                    // router.push('/login')
                    break;
                default:
                    // console.log('默认')
            }
            // console.log(error.response)
            return Promise.reject(error.response);
        }
        return Promise.reject(error)
    }
)

// 请求封装
// GET
Vue.prototype.$get = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}

// POST
Vue.prototype.$post = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/axios.js